<template>
  <b-nav-item-dropdown
    class="dropdown-notification mr-25 ml-1"
    ref="dropdown"
    @show="doSomething"
    @click="handIsActive"
    @hidden="setIsShownNotify"
    menu-class="dropdown-menu-media"
    toggle-class="nav-link-custom"
  >
    <template #button-content>
      <!-- <feather-icon
        :badge="currentTotal > 99 ? '99+' : currentTotal"
        badge-classes="bg-danger"
        class="text-body"
        icon="BellIcon"
        size="21"
      /> -->

      <div class="position-relative notify-icon">
        <!-- <img
          src="@/assets/images/icons/new-icon/notify.png"
          width="20px"
          alt=""
        /> -->
        <Notification width="25px" height="25px" v-if="!isShownNotify" />
        <NotificationActive v-else width="25px" height="25px" />

        <span class="position-absolute count-notify text-center">{{
          currentTotal > 99 ? "99+" : currentTotal
        }}</span>
      </div>
      <!-- <img
        src="@/assets/images/icons/new-icon/notify.png"
        width="20px"
        :badge="currentTotal > 99 ? '99+' : currentTotal"
        alt=""
      /> -->

      <!-- <img
        class="disabled-select"
        width="25px"
        height="25px"
        style="margin-top: -1px"
        src="@/assets/images/svg/Resolved-ticket.svg"
      /> -->
    </template>

    <!-- Header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">
          {{ $t("notifications") }}
        </h4>
        <div v-click-outside="() => (isShowTitle = false)">
          <feather-icon
            size="18"
            @click="isShowTitle = !isShowTitle"
            icon="MoreVerticalIcon"
            class="icon-mark cursor-pointer"
          />

          <div v-show="isShowTitle" class="title-more" @click="handReadAll">
            <feather-icon
              size="18"
              icon="CheckIcon"
              class="icon-mark cursor-pointer"
            />
            {{ $t("MarkAllAsRead") }}
          </div>
        </div>
      </div>
    </li>

    <!-- Notifications -->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="scrollable-container media-list scroll-area overflow-hidden"
      tagname="li"
    >
      <!-- Account Notification -->
      <b-overlay
        :show="isOpen"
        rounded
        opacity="0.6"
        spinner-small
        spinner-variant="primary"
      >
        <div class="header-action">
          <b-badge variant="primary" @click="loadAllReadOrUnRead(null)"
            >All</b-badge
          >
          <b-badge
            variant="primary"
            class="ml-2"
            @click="loadAllReadOrUnRead(true)"
            >Unread</b-badge
          >
        </div>

        <b-link
          class="py-1 d-block text-center bg-white"
          v-if="notifications.length == 0"
        >
          No Notifications Found
        </b-link>
        <b-link v-for="notification in notifications" :key="notification.id">
          <b-media
            @mouseleave="hideShownItem(notification.id)"
            :class="notification.readed == 0 ? 'bg-read' : ''"
          >
            <p class="media-heading">
              <span
                :class="{ 'font-weight-bolder': notification.readed == 0 }"
                @click="handListNotify(notification)"
              >
                {{ notification.notify_config_name }}
              </span>

              <feather-icon
                size="12"
                @click="shownItemById(notification.id, !notification.shown)"
                icon="MoreVerticalIcon"
                :class="[
                  'icon-circle cursor-pointer',
                  notification.readed == 0
                    ? 'active-notify'
                    : 'bg-white rounded-circle d-none',
                ]"
              />
            </p>
            <div v-show="notification.shown" class="drop-more-vertical">
              <div
                class="drop-more-vertical_mark"
                @click="handMarkUnread(notification.id)"
              >
                <feather-icon
                  size="20"
                  icon="CheckIcon"
                  class="icon-mark cursor-pointer"
                />
                {{ $t("MarkUnread") }}
              </div>
              <div
                class="drop-more-vertical_remove"
                @click="handDeleteByID(notification.id)"
              >
                <feather-icon
                  size="20"
                  icon="XIcon"
                  class="icon-mark cursor-pointer"
                />
                {{ $t("Remove") }}
              </div>
            </div>
            <p
              style="
                display: block;
                line-height: 1.5em;
                overflow: hidden;
                margin: 0;
              "
              @click="handListNotify(notification)"
              class="notification-text"
            >
              {{
                $i18n.locale == "en"
                  ? notification.message
                  : notification.message_vn
              }}
            </p>
            <small class="text-small">{{ notification.created_date }}</small>
          </b-media>
        </b-link>
      </b-overlay>

      <!-- System Notification Toggler -->
    </vue-perfect-scrollbar>

    <!-- Cart Footer -->
    <li class="dropdown-menu-footer">
      <!-- <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        @click="handGoNotify"
        block
        >{{ $t("ViewAll") }}</b-button
      > -->
      <div @click="handGoNotify">{{ $t("ViewAll") }}</div>
    </li>
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown,
  BBadge,
  BMedia,
  BLink,
  BAvatar,
  BButton,
  BFormCheckbox,
} from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Ripple from "vue-ripple-directive";
import {
  reactive,
  ref,
  computed,
  onBeforeUnmount,
  getCurrentInstance,
} from "@vue/composition-api";
import { useRoute } from "vue-router";
import { Utils } from "@core/utils/utilsCustom";
import ClickOutside from "vue-click-outside";
import Notification from "@/assets/images/icons/file-icons/Notification.svg?external";
import NotificationActive from "@/assets/images/icons/file-icons/notify-active.svg?external";
export default {
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    BAvatar,
    VuePerfectScrollbar,
    BButton,
    BFormCheckbox,
    Notification,
    NotificationActive,
  },
  directives: {
    Ripple,
    ClickOutside,
  },

  setup(props, context) {
    const instance = getCurrentInstance();
    const router = context.root.$router;
    var store = context.root.$store;
    const userData = JSON.parse(localStorage.getItem("userData"));
    const isActive = ref(false);
    const isOpen = ref(false);
    const isShowTitle = ref(false);
    const dropdown = ref(null);
    const isShownNotify = ref(false);

    let currentTotal = computed(function () {
      return store.state.notify.totalNotifications;
    });
    let notifications = computed(function () {
      return store.state.notify.notifications.slice(0, 5);
    });
    const updateCurrentTime = () => {
      store.dispatch("notify/GET_NOTIFICATION");
    };
    const setIsShownNotify = (v) => {
      isShownNotify.value = !isShownNotify.value;
    };
    const shownItemById = (id, value) => {
      return store.commit("notify/SET_SHOWS_BY_ID", { id, value });
    };

    const hideShownItem = (id) => {
      return store.commit("notify/SET_HIDE_BY_ID", id);
    };
    const intervalHandle = setInterval(updateCurrentTime, 5 * 60 * 1000);
    updateCurrentTime();
    onBeforeUnmount(() => {
      clearInterval(intervalHandle);
    });

    const handIsActive = (v) => {
      isActive.value != isActive.value;
    };

    const doSomething = () => {
      setIsShownNotify();
      const path = `/notifications`;
      store.dispatch("notify/GET_NOTIFICATION");
      if (router.currentRoute.fullPath !== path) {
        updateCurrentTime();
        isOpen.value = true;

        loadItem();
      }
    };

    const loadItem = () => {
      store
        .dispatch("notify/GET_NOTIFY_BY_USER", {
          search: "",
          page: 1,
          pageSize: 5,
        })
        .then(() => {
          isOpen.value = false;
        });
    };
    const handListNotify = (notify) => {
      // router.replace({
      //   name: "home",
      // }).catch((error) => {});
      dropdown.value.visible = false;
      
      // const path = `/notifications`;
      // isActive.value != isActive.value;
      // if (router.currentRoute.fullPath !== path) router.push(path);
      if (notify.notify_config_code === "ACCOUNT_NEED_APPROVAL") {
        router
          .replace({
            name: "approve-register",
          })
          .catch((error) => {});
        return;
      }

      if (notify.readed == 0) {
        store
          .dispatch("notify/UPDATE_NOTIFY", {
            ids: notify.id.toString(),
            markAllAsRead: "0",
          })
          .then(() => {
            store.commit("notify/SET_UPDATE_READ_BY_ID", notify.id);
          })
          .finally(() => {
            store.dispatch("notify/GET_NOTIFICATION");
          });
      }

      if (
        userData.userType == Utils.CONSTANTS.USER_TYPE_O.Admin_Sale ||
        userData.userType == Utils.CONSTANTS.USER_TYPE_O.Admin
      ) {
        store.commit("tabView/SET_OBJECT_ID", notify.object_id);
          store.commit("tabView/SET_OBJECT_STATUS", notify.object_status);
        if (
          notify.notify_config_code === "BOOKING_HAS_BOOKING" ||
          notify.notify_config_code.includes("BOOKING") || notify.notify_config_code === "BOOKING_REQUEST_AN_UPDATE"
        ) {
          store.commit("tabView/SET_OBJECT_TYPE", notify.notify_config_code);
          router
            .replace({
              name: "my-wr1-booking",
              params: {
                idBooking: notify.object_id,
              },
            })
            .catch((error) => {});
          return;
        }

        if (
          Utils.CONSTANTS.STATUS_WR1.BOOKING.split(",")
            .map(Number)
            .includes(notify.object_status)
        ) {
          router
            .replace({
              name: "my-wr1-booking",
              params: {
                idBooking: notify.object_id,
              },
            })
            .catch((error) => {
              // const path = `/notifications`;
              // router.push(path);
            });
        
        } else {
          store.commit("tabView/SET_OBJECT_ID", notify.object_id);
          store.commit("tabView/SET_OBJECT_STATUS", notify.object_status);

          router
            .replace({
              name: "my-wr1-quotation",
              params: {
                idQuo: notify.object_id,
              },
            })
            .catch((error) => {});
        }
      } else {
        if (
          Utils.CONSTANTS.STATUS_WR1.BOOKING.split(",")
            .map(Number)
            .includes(notify.object_status)
        ) {
          store.commit("tabView/SET_OBJECT_ID", notify.object_id);
          store.commit("tabView/SET_OBJECT_STATUS", notify.object_status);
          router
            .replace({
              name: "user-my-booking",
              params: {
                idBooking: notify.object_id,
              },
            })
            .catch((error) => {});

          if (
            notify.notify_config_code === "BOOKING_HAS_BOOKING" ||
            notify.notify_config_code.includes("BOOKING")
          ) {
            router
              .replace({
                name: "user-my-booking",
                params: {
                  idBooking: notify.object_id,
                },
              })
              .catch((error) => {});
            return;
          }
        } else {
          store.commit("tabView/SET_OBJECT_ID", notify.object_id);
          store.commit("tabView/SET_OBJECT_STATUS", notify.object_status);
          router
            .replace({
              name: "user-my-quotation",
              params: {
                idQuo: notify.object_id,
              },
            })
            .catch((error) => {});
        }
      }
    };
    /* eslint-disable global-require */
    const handGoNotify = () => {
      dropdown.value.visible = false;

      const path = `/notifications`;
      isActive.value != isActive.value;
      if (router.currentRoute.fullPath !== path) router.push(path);
    };

    /* eslint-disable global-require */

    const perfectScrollbarSettings = {
      maxScrollbarLength: 250,
      wheelPropagation: false,
    };

    const handReadAll = () => {
      store
        .dispatch("notify/UPDATE_NOTIFY", {
          ids: "",
          markAllAsRead: 1,
        })
        .then(() => {
          store.commit("notify/RESET");
          store.dispatch("notify/GET_NOTIFICATION");
          loadItem();
        });
    };
    const handDeleteByID = (id) => {
      store
        .dispatch("notify/DELETE_NOTIFY", {
          id: id,
        })
        .then(() => {
          store.commit("notify/RESET");
          store.dispatch("notify/GET_NOTIFICATION");
          loadItem();
        });
    };

    const handMarkUnread = (id) => {
      store
        .dispatch("notify/UNREAD_NOTIFY", {
          ids: id,
          markAsUnRead: 1,
        })
        .then(() => {
          store.commit("notify/RESET");
          store.dispatch("notify/GET_NOTIFICATION");
          loadItem();
        });
    };

    const loadAllReadOrUnRead = (isReaded) => {
      store
        .dispatch("notify/GET_NOTIFY_BY_USER", {
          search: "",
          page: 1,
          pageSize: 5,
          readed: isReaded == null ? null : isReaded ? 0 : 1,
        })
        .then(() => {
          isOpen.value = false;
        });
    };

    return {
      hideShownItem,
      shownItemById,
      isShowTitle,
      notifications,
      perfectScrollbarSettings,
      isActive,
      handIsActive,
      isOpen,
      doSomething,
      handGoNotify,
      dropdown,
      currentTotal,
      handListNotify,
      handReadAll,
      handDeleteByID,
      handMarkUnread,
      loadAllReadOrUnRead,
      isShownNotify,
      setIsShownNotify,
    };
  },
};
</script>

<style>
.bg-read {
  background: #31a79f0f;
}
.count-notify {
  color: #fff;
  position: absolute !important;
  top: -11px;
  right: -12px;
  padding-left: 0.8rem;
  padding-right: 0.8rem;
  background: #ea5455 !important;
  /* padding: 5px; */
  min-width: 1.429rem;
  min-height: 1.429rem;
  border-radius: 100px;
  font-size: 0.786rem;
  line-height: 1.86;
}
.ps__thumb-y {
  background-color: rgba(40, 147, 140, 0.56) !important;
}
</style>
